import { VerifyStatus } from 'api/LoanOfferApi';

import { StudentLoanForgivenessResults } from './StudentLoanForgivenessFlowResults';

export enum YourNameResult {
  Exit = 'Exit',
  ConfirmYourCredentials = 'ConfirmYourCredentials',
}

export enum VerifyCodeResult {
  DifferentEmailSession = 'differentEmailSession',
  DifferentPhoneNumberSession = 'differentPhoneNumberSession',
}

export enum VerifyPhoneNumberResult {
  CanReapply = 'CanReapply',
}

export enum VerifyEmailResult {
  CardFlow = 'CardFlow',
}

export enum YourGoalResult {
  CardCrossSell = 'CardCrossSell',
}

export enum YourIncomeResult {
  CardWaitlist = 'CardWaitlist',
  CardCrossSell = 'CardCrossSell',
}

export enum ApplyingResult {
  Done = 'Done',
  Error = 'Error',
  UnfreezeCreditScore = 'UnfreezeCreditScore',
  SessionExpired = 'sessionExpired',
}

export enum ReferralProgramResult {
  NextSteps = 'NextSteps',
  FinancialDashboard = 'FinancialDashboard',
}

export enum DontShareResult {
  Continue = 'Continue',
  Decline = 'Decline',
}

export enum ConfirmLoanResult {
  Continue = 'Continue',
  BackToFinancialDashboard = 'BackToFinancialDashboard',
  MakeChanges = 'MakeChanges',
}

export enum LoaderResult {
  NoOffer = 'NoOffer',
  Success = 'Success',
  CantGenerateOffer = 'CantGenerateOffer',
}

export enum MakingPaymentResult {
  Success = 'Success',
  Failure = 'Failure',
}

export enum OfferStatusResult {
  BackToCard = 'BackToCard',
  BackToFinancialDashboard = 'BackToFinancialDashboard',
}

export enum YourContactResult {
  Continue = 'Continue',
  OutOfState = 'OutOfState',
}

export enum EmploymentDetailsResult {
  Continue = 'Continue',
  Rejected = 'Rejected',
}

export enum UpdateVerificationDataResult {
  Continue = 'Continue',
}

export enum ApplyEmployeeLoanResult {
  Apply = 'Apply',
  ThanksForJoining = 'ThanksForJoining',
}

export enum SetupAccountResult {
  AllStepsCompleted = 'AllStepsCompleted',
}

export enum StepsResult {
  Completed = 'Completed',
  Rejected = 'Rejected',
}

export enum AlloyKycResult {
  Continue = 'Continue',
  Rejected = 'Rejected',
}

export enum MakeAPaymentResult {
  Authorization = 'Authorization',
  MakePayment = 'MakePayment',
  PlaidConnection = 'PlaidConnection',
}

export enum CheckingAccountResult {
  Continue = 'Continue',
  MakePayment = 'MakePayment',
  Failure = 'Failure',
}

export enum MissedPaymentResult {
  CollectReason = 'CollectReason',
  Error = 'Error',
}

export enum ConnectPaycheckResult {
  Next = 'Next',
  NotNow = 'NotNow',
}

export enum CardNextResult {
  FromReferral = 'fromReferral',
  FromCardApplied = 'fromCardApplied',
}

export enum ConfirmYourDetailsResult {
  UpdateFields = 'UpdateFields',
}

export enum CardSummaryResult {
  NotNow = 'NotNow',
  Done = 'Done',
  Error = 'Error',
  SessionExpired = 'sessionExpired',
}

export enum FeedbackResult {
  CrossSell = 'CrossSell',
}

export enum AdditionalFundsResult {
  ModifiedFunds = 'ModifiedFunds',
  NoChanges = 'NoChanges',
}

export enum SelectDebtsResult {
  NoChanges = 'NoChanges',
  FinalizeReviewOffer = 'FinalizeReviewOffer',
  FundsRemaining = 'FundsRemaining',
}

export enum VerifyIncomeResult {
  UpdateAnnualIncome = 'UpdateAnnualIncome',
}

export enum YourEmployerResult {
  IncomeRequired = 'IncomeRequired',
}

export enum YourSSN4Result {
  CardCrossSell = 'CardCrossSell',
  SessionExpired = 'sessionExpired',
  Error = 'Error',
}

export enum RepaymentMethodResult {
  CompletedRepaymentAccountStep = 'CompletedRepaymentAccountStep',
}

export enum RepaymentDecisionResult {
  Yes = 'Yes',
  No = 'No',
}

export enum WhatIsTheIssueResult {
  EmployerRestriction = 'EmployerRestriction',
  RoutingNumberNotRecognized = 'RoutingNumberNotRecognized',
  Other = 'Other',
}

export enum VerificationNavigationResult {
  OfferChanged = 'OfferChanged',
}

export type FlowNextResult =
  | YourNameResult
  | VerifyCodeResult
  | VerifyPhoneNumberResult
  | VerifyEmailResult
  | YourGoalResult
  | YourIncomeResult
  | ApplyingResult
  | ReferralProgramResult
  | DontShareResult
  | ConfirmLoanResult
  | LoaderResult
  | MakingPaymentResult
  | OfferStatusResult
  | YourContactResult
  | EmploymentDetailsResult
  | UpdateVerificationDataResult
  | SetupAccountResult
  | StepsResult
  | VerifyStatus
  | AlloyKycResult
  | MakeAPaymentResult
  | CheckingAccountResult
  | StudentLoanForgivenessResults
  | MissedPaymentResult
  | ConnectPaycheckResult
  | CardNextResult
  | ApplyEmployeeLoanResult
  | ConfirmYourDetailsResult
  | CardSummaryResult
  | FeedbackResult
  | AdditionalFundsResult
  | SelectDebtsResult
  | VerifyIncomeResult
  | YourEmployerResult
  | YourSSN4Result
  | RepaymentMethodResult
  | RepaymentDecisionResult
  | WhatIsTheIssueResult
  | VerificationNavigationResult
  | undefined;
